<template>
  <div>
    <ReportTable :data="'const' in data ? data['const'] : data"
                 :headers="headers"
                 :loading="loading"
                 :sort-by="['value','name']"
                 :is-searchable="false"
                 :is-downloable="true"
                 :is-movable="false"
                 :is-groupable="true"
                 :table-name="tableName" />
  </div>
</template>

<script>
import ReportTable from '../../ReportTable'

export default {
    name: "ReportIndicatorConsult",

    components: {ReportTable},
    props: {
      data: {
        type: [Array, Object],
        default: null
      },
       loading: {
          type: Boolean,
          default: true
        },
      tableName: {
          type: String,
          default: 'Консультации'
        }
    },
    data: () => ({
      pagination: {
        sortBy: 'name'
      },
      selected: [],

      isLoading: true,
      headers:  [
          {text: '', value: '', align: 'd-none',class: ['d-none']},
          {text: 'Название', value: 'name', align: 'left', sortable: true},
          {text: 'Количество', value: 'value', align: 'left', sortable: true},
          {text: 'Отчет', value: 'report_type_group', align: 'd-none',class: ['d-none']},
          {text: 'Отчет', value: 'report_type', align: 'left'},
      ],

    }),
    // computed: {
    //   headers () {
    //     if (this.data.hasOwnProperty('const')) {
    //     const entries = Object.entries(this.data['const'])
    //     let headers = []
    //     entries.forEach(function (item, index) {
    //       headers.push({'text':item[0],'value':item[0]})
    //     });
    //     if (headers.length===0) headers=['empty']
    //     return headers
    //     }
    //   }
    // },
    watch: {
      data (newValue) {
        this.data = newValue
        //console.log(this.data,newValue)
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/pages/indicators/ReportIndicatorConsult.vue